import { call, put, takeLatest } from 'redux-saga/effects';
import { queryRequest } from '../../utils/request';
// import { push } from 'react-router-redux';
import { searchArOpsUnit, getArOpsUnitById } from '../../api';
import { resetNotification, setNotification } from '../Notification/actions';
import { NotificationTypes } from '../../constantsApp';
import { isConnecting, isEndConnected } from '../Loader/actions';
import * as types from './constants';
import * as actions from './actions';

export function* getArOpsUnitSaga({ payload, cb }) {
  yield put(isConnecting());
  yield put(resetNotification());
  try {
    const { page, size, filter, sort } = payload;
    const response = yield call(queryRequest, searchArOpsUnit({ page, size, filter, sort }));
    yield put(actions.getArOpsUnitSuccess(response.searchArOpsUnit));
    yield put(isEndConnected());
    if (cb) cb({ success: true, data: response.searchArOpsUnit });
  } catch (err) {
    yield put(isEndConnected());
    yield put(
      setNotification({
        type: NotificationTypes.error,
        message: `Search Transaction Unit failed ${err}`,
      })
    );
    if (cb) cb({ success: false, data: null });
  }
}

export function* getArOpsUnitByIdSaga({ payload, cb }) {
  try {
    const response = yield call(queryRequest, getArOpsUnitById(payload));
    if (response.getArOpsUnitById) {
      if (cb) cb({ success: true, data: response.getArOpsUnitById });
    } else if (cb) cb({ success: false, data: [] });
  } catch (err) {
    if (cb) cb({ success: false, data: [] });
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* viewTransactionsPageSaga() {
  yield takeLatest(types.GET_AR_OPS_UNIT, getArOpsUnitSaga);
  yield takeLatest(types.GET_AR_OPS_UNIT_BY_ID, getArOpsUnitByIdSaga);
}
